<div class="header-section-main" *ngIf="!!cardDetails">
    <div class="box">
        <h1 class="card-name"  [innerHTML]="(cardDetails?.cardName ? ((cardDetails?.cardName + (cardDetails?.cardNameTagLine ? cardDetails?.cardNameTagLine : '')) | safeHtml) : '')"></h1>
        <div class="header-cards">
            <div class="image-rating-button">
                <div class="co-brand-logo" *ngIf="!isDesktop() && headerContent?.coBrandLogo">
                    <img [src]="headerContent?.coBrandLogo | adaFriendlyName: 'ignoreHtmlTags'"  [alt]="headerContent?.coBrandLogoAlt"/>
                </div>
                <div *ngIf="isMobile() && !cardDetails?.reOrder">
                    <div *ngIf="isMobileScreenSize$" class="card-tagline">
                        <h2 [innerHTML]="cardDetails?.cardTagLine | safeHtml"></h2>
                        <div class="card-tagline-desc" [innerHTML]="headerContent?.cardTaglineDesc | safeHtml"></div>
                    </div>    
                </div>
                <div *ngIf="isMobile() && cardDetails?.reOrder">
                    <div *ngIf="isMobileScreenSize$ | async" class="card-tagline">
                        <h2 [innerHTML]="cardDetails?.cardTagLine | safeHtml"></h2>
                        <div class="card-tagline-desc" [innerHTML]="headerContent?.cardTaglineDesc | safeHtml"></div>
                        <div class="right">
                            <div class="spacer-10" role="presentation" aria-hidden="true" *ngIf="!headerContent?.cardTaglineDesc"></div>
                                <ui-card-button [btnName]="cardDetails?.cardApplyNowBtnText" *ngIf="cardDetails?.cardName" [tagText]="cardDetails?.cardApplyNowBtnText.toLowerCase()+' top'"
                                [btnLink]="cardApplyNowBtnLink" [cardName]="cardDetails?.cardName" [hrefTarget]="hrefTarget"  (click)="applyNow('applyNowHero')">
                                </ui-card-button>
                                <div class="promo-offer-disclaimer" [innerHTML]="headerContent?.offerDisclaimer" *ngIf="headerContent?.offerDisclaimer">
                                </div>
                                <div class="spacer-10" role="presentation" aria-hidden="true" *ngIf="!headerContent?.offerDisclaimer"></div>
                                <div class="pricing-link" *ngIf="!(isStackedSwipeZoneDisplayed$ | async).displayOnMobile">
                                <a id="Pricing" target="_blank" rel="noopener" [attr.data-id]="'termsUrl-'+cardDetails?.pid" class="btn btn-link"
                                [innerHTML]="cardDetails?.cardPricingDetailText"
                                [attr.aria-label]="(cardDetails?.cardName + ' ' + cardDetails?.cardPricingDetailText | adaFriendlyName: 'ariaLabel')"
                                (click)="anchorLink(cardDetails?.pricingAndInfoText)"></a>
                                <div class="customer-support">
                                    <a *ngIf="headerContent?.callToApply?.callToApplyText" role="link" #calltoApply class="btn btn-link" tabindex="0" (click)="openCallToApply($event)"
                                    [innerHTML]="headerContent?.callToApply?.callToApplyText"
                                    ></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div *ngIf="isReOrder()">
                    <div class="co-brand-logo" *ngIf="headerContent?.coBrandLogo">
                        <img [src]="headerContent?.coBrandLogo | adaFriendlyName: 'ignoreHtmlTags'"  [alt]="headerContent?.coBrandLogoAlt"/>
                    </div>
                    <div class="card-tagline">
                        <h2 [innerHTML]="cardDetails?.cardTagLine | safeHtml"></h2>
                        <div class="card-tagline-desc" [innerHTML]="headerContent?.cardTaglineDesc | safeHtml"></div>
                    </div>    
                </div>
                <div *ngIf="headerContent?.offerActive" class="header-feature-flag">
                    <div class="green-tag-best-award" *ngIf="headerContent.offerType === 'image'">
                        <span class="best-award"
                            [ngStyle]="{'background-image': 'url(' + headerContent.offerImagePath + ')'}"
                        ></span>
                        <span class="green-tag-support-text-highlight promo-header"
                            [ngStyle]="{'background-color': headerContent.backgroundColor, 'color': headerContent.textColor}"
                            [innerHTML]="headerContent?.offerTitle | adaFriendlyName: 'ignoreHtmlTags'"
                        ></span>
                    </div>
                    <div class="green-tag-low-intro" id="greenTagLowIntro" *ngIf="headerContent.offerType === 'text'">
                        <div class="green-tag"
                            [ngStyle]="{'background-color': headerContent.backgroundColor, 'color': headerContent.textColor,'top':'10'}">
                            <span class="green-tag-text promo-header"
                                [innerHTML]="headerContent?.offerTitle | adaFriendlyName: 'ignoreHtmlTags' | safeHtml"
                            ></span>
                        </div>
                    </div>
                </div>
                <div class="spacer-10" role="presentation" aria-hidden="true"></div>
                <app-card-art
                    *ngIf="isCardArtReady"
                    id="pdpMainCardArt"
                    [pid]="cardDetails?.pidPT"
                    [defaultSize]="cardImageSize"
                    [linkHref]="cardApplyNowBtnLink"
                    [linkTarget]="'_blank'"
                    [enablePdpLink]="false"
                    (click)="applyNow('cardImageHero')"
                    [imgCache]="false"
                ></app-card-art>
                <div class="card-rating">
                    <ui-card-rating [pid]="cardDetails?.pid" (handleReviewClick)="scrollToReviewSection('reviewSection')"
                        [title]="cardDetails?.cardName" *ngIf="reviewContent?.reviewActive" [hideDetailReview]="false" [disableReviewModal]="true" [scrollToSection]="true">
                    </ui-card-rating>
                </div>
                <div class="spacer-10" role="presentation" aria-hidden="true"></div>
            </div>
            <div class="right" *ngIf="isMobile() && !cardDetails.reOrder">
                <ui-card-button [btnName]="cardDetails?.cardApplyNowBtnText" *ngIf="cardDetails?.cardName" [tagText]="cardDetails?.cardApplyNowBtnText.toLowerCase()+' top'"
                    [btnLink]="cardApplyNowBtnLink" [cardName]="cardDetails?.cardName" [hrefTarget]="hrefTarget"  (click)="applyNow('applyNowHero')">
                </ui-card-button>
                <div class="promo-offer-disclaimer" [innerHTML]="headerContent?.offerDisclaimer" *ngIf="headerContent?.offerDisclaimer">
                </div>
                <div class="spacer-10" role="presentation" aria-hidden="true" *ngIf="!headerContent?.offerDisclaimer"></div>
                <div class="pricing-link" *ngIf="!(isStackedSwipeZoneDisplayed$ | async).displayOnMobile">
                    <a id="Pricing" target="_blank" rel="noopener" [attr.data-id]="'termsUrl-'+cardDetails?.pid" class="btn btn-link"
                    [innerHTML]="cardDetails?.cardPricingDetailText"
                    [attr.aria-label]="(cardDetails?.cardName + ' ' + cardDetails?.cardPricingDetailText | adaFriendlyName: 'ariaLabel')"
                    (click)="anchorLink(cardDetails?.pricingAndInfoText)"></a>
                    <div class="customer-support">
                        <button *ngIf="headerContent?.callToApply?.callToApplyText" role="link" #calltoApply class="btn btn-link" tabindex="0" (click)="openCallToApply($event)"
                        [innerHTML]="headerContent?.callToApply?.callToApplyText"
                        ></button>
                    </div>
                </div>
            </div>
            <div class="right" *ngIf="!isMobile()">
                <div class="co-brand-logo" *ngIf="isDesktop() && headerContent?.coBrandLogo">
                    <img [src]="headerContent?.coBrandLogo | adaFriendlyName: 'ignoreHtmlTags'"  [alt]="headerContent?.coBrandLogoAlt" *ngIf="headerContent?.coBrandLogo"/>
                </div>
                <div class="spacer-30" role="presentation" aria-hidden="true" *ngIf="!headerContent?.coBrandLogo && !isMobile()"></div>
                <div *ngIf="isTabletAndBeyondSize$ | async" class="card-tagline">
                    <h2 [innerHTML]="cardDetails?.cardTagLine | safeHtml"></h2>
                    <div class="card-tagline-desc" [innerHTML]="headerContent?.cardTaglineDesc | safeHtml"></div>
                </div>
                <div class="spacer-10" role="presentation" aria-hidden="true" *ngIf="!headerContent?.cardTaglineDesc"></div>
                <ui-card-button [btnName]="cardDetails?.cardApplyNowBtnText" *ngIf="cardDetails?.cardName" [tagText]="cardDetails?.cardApplyNowBtnText.toLowerCase()+' top'"
                    [btnLink]="cardApplyNowBtnLink" [cardName]="cardDetails?.cardName" [hrefTarget]="hrefTarget"  (click)="applyNow('applyNowHero')">
                </ui-card-button>
                <div class="promo-offer-disclaimer" [innerHTML]="headerContent?.offerDisclaimer" *ngIf="headerContent?.offerDisclaimer" (click)="pricingInfo('pricingInfoLinkHero')">
                </div>
                <div class="spacer-10" role="presentation" aria-hidden="true" *ngIf="!headerContent?.offerDisclaimer"></div>
                <div class="pricing-link" *ngIf="!(isStackedSwipeZoneDisplayed$ | async).displayOnMobile">
                    <a id="Pricing" target="_blank" rel="noopener" [attr.data-id]="'termsUrl-'+cardDetails?.pid" cdsButton="inlineLink"
                    [innerHTML]="cardDetails?.cardPricingDetailText"
                    [attr.aria-label]="(cardDetails?.cardName + ' ' + cardDetails?.cardPricingDetailText | adaFriendlyName: 'ariaLabel')"
                    (click)="pricingInfo('pricingInfoLinkHero')"></a>
                    <div class="customer-support">
                        <button *ngIf="headerContent?.callToApply?.callToApplyText" role="link" #calltoApply cdsButton="inlineLink" tabindex="0" (click)="openCallToApply($event)"
                        [innerHTML]="headerContent?.callToApply?.callToApplyText"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="stacked-swipe-zone">
            <app-pdp-stacked-swipe-zone [headerContent]="headerContent" [stackedZoneDisplayFlags]="isStackedSwipeZoneDisplayed$ | async" (taggingEmit)="taggingEmit.emit($event)"></app-pdp-stacked-swipe-zone>
            <div class="pricing-link" *ngIf="(isStackedSwipeZoneDisplayed$ | async).displayOnMobile">
                <a id="Pricing" target="_blank" rel="noopener" [attr.data-id]="'termsUrl-'+cardDetails?.pid" cdsButton="inlineLink"
                    [innerHTML]="cardDetails?.cardPricingDetailText"
                    [attr.aria-label]="(cardDetails?.cardName + ' ' + cardDetails?.cardPricingDetailText | adaFriendlyName: 'ariaLabel')"
                    (click)="anchorLink(cardDetails?.pricingAndInfoText)"></a>
                <div class="customer-support">
                    <button *ngIf="headerContent?.callToApply?.callToApplyText" role="link" #calltoApply cdsButton="inlineLink" tabindex="0" (click)="openCallToApply($event)"
                    [innerHTML]="headerContent?.callToApply?.callToApplyText"
                    ></button>
                </div>
            </div>
        </div>
        <div class="header-description-wrapper" *ngIf="!(isStackedSwipeZoneDisplayed$ | async).displayOnMobile && !(isStackedSwipeZoneDisplayed$ | async).displayOnDesktop">
            <div class="header-description">
                <div class="bubble-section" *ngFor="let promo of headerContent?.description">
                <div class="bubble-body" *ngIf="promo?.topHeaderText" [innerHTML]="promo?.topHeaderText | safeHtml"></div>
                    <h3 class="bubble-header">
                        <span class="number" *ngIf="promo?.number" [innerHTML]="promo?.number | safeHtml"></span>
                        <span class="text" *ngIf="promo?.text" [innerHTML]="promo?.text | safeHtml"></span>
                        <span class="header" *ngIf="promo?.headerText" [innerHTML]="promo?.headerText | safeHtml"></span>
                    </h3>
                    <div class="bubble-body" *ngIf="promo?.description" [innerHTML]="promo?.description | safeHtml"></div>
                </div>
            </div>
        </div>
        <div class="offer-additional-info" *ngIf="headerContent?.offerSummary" [innerHTML]="headerContent?.offerSummary | safeHtml"></div>
        <div class="additional-info" *ngIf="headerContent?.additionalInformationText" (click)="pricingInfo('additionalInfoLinkHero'); additionalInfo($event)" [innerHTML]="headerContent?.additionalInformationText | safeHtml"></div>
        <div class="extra-info">
            <!-- <div *ngFor="let item of cardDetails?.cardHighlights" [innerHTML]="item | safeHtml"></div> -->
            <div *ngIf="cardDetails?.cardFaqtext" class="faq">
                <button role="link" cdsButton="inlineLink" [innerHTML]="cardDetails?.cardFaqtext"
                    (click)="[scroll('#faqSection'), anchorLink(cardDetails?.cardFaqtext)]" id="faq"></button>
            </div>
        </div>
    </div>
</div>
